
import React from 'react';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { useTranslator } from '@jutro/locale';

import metadata from './MLClaimDetailsHOInvolved.metadata.json5';
import messages from './MLClaimDetailsHOInvolved.messages';

function MLClaimDetailsHOInvolved(props) {
    const {
        propertyOwner
    } = props;
    const translator = useTranslator();


    const getPrimaryAddress = (object) => {
        const address = object && object.primaryAddress;
        if (address) {
            return <>
                {address.addressLine1}
                <br />
                {`${address.city}, ${address.state} ${address.postalCode}`}
            </>
        }
    }

    const getPhoneNumber = (number, extension, parenIndicator) => {
        if (!number) { return ''; }
        number = String(number).replace(/[^0-9]+/g, '');

        const DELIMITER = '-';
        const US_PREFIX = '1';

        // Check for a possible prefix included and remove if so
        if (number.length === 11 && number[0] === US_PREFIX) {
            number = number.slice(1);
        }

        // If the length is not 10, the number format is wrong
        if (number.length !== 10) {
            return number;
        }

        const area = number.substring(0, 3);
        const front = number.substring(3, 6);
        const end = number.substring(6, 10);
        let formattedNumber;
        if (parenIndicator) {
            formattedNumber = `(${area}) ${front}${DELIMITER}${end}`;
        } else {
            formattedNumber = area + DELIMITER + front + DELIMITER + end;
        }
        let formattedExtension = '';
        if (extension) {
            const ext = String(extension).replace(/[^0-9]+/g, '');
            if (ext) {
                formattedExtension = ` ${translator(messages.ext)} ${ext}`;
            }
        }
        return formattedNumber.concat(formattedExtension);
    }
    
    const overrides = {
        HOInvolvedComponent: {
            visible: !!propertyOwner
        },
        youName: {
            content: propertyOwner?.contactDTO?.displayName
        },
        youAddress: {
            content: getPrimaryAddress(propertyOwner?.contactDTO)
        },
        youContactNumber: {
            visible: !!propertyOwner?.contactDTO?.contactNumber_ML,
            content: <>{`${translator(messages.Phone)} ${getPhoneNumber(propertyOwner?.contactDTO?.contactNumber_ML)}`}</>
        },
    };
    const resolvers = {
        resolveClassNameMap: {},
        resolveComponentMap: {
        },
        resolveCallbackMap: {
        }
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            {...resolvers} />
    );
}

export default MLClaimDetailsHOInvolved;
